import { Centers } from 'hooks/useCenters';
import { IMasterDataDto } from 'models/MasterData';

export const excludeDirectionCenter = (
  center: IMasterDataDto,
): boolean => center.code !== Centers.DIRECTION;
